var $a5e017be22c4225e$exports = {};
$a5e017be22c4225e$exports = {
    "colorFormat": `F\xe4rgformat`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$a5e017be22c4225e$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
